import { useCallback } from 'react';

import type { LeaseActionProps } from '../../../models/Types';
import CountersigningRequestModal from './OpenModalCountersign/CountersigningRequestModal';

export default function OpenModalCountersign({ lease, property, history, terminateActiveAction }: LeaseActionProps) {
  const startSigning = useCallback(() => {
    terminateActiveAction();
    history.push(lease.isSelfUpload ? lease.getSelfServePreviewPath() : lease.getPreviewPath());
  }, [lease, history, terminateActiveAction]);

  return (
    <CountersigningRequestModal
      propertyAddress={property ? property.streetAddress : ''}
      onClose={terminateActiveAction}
      startSigning={startSigning}
    />
  );
}
